import comp from "./TagSnpModalV2";
export default comp;
